export enum LorenAggregate {
    MINUTES = 'minute',
    HOURS = 'hour'
}
